var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social/outline/facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2998",
    d: "M18.5 3H15.5C12.7386 3 10.5 5.23858 10.5 8V10H6.5V14H10.5V21H14.5V14H18.5V10H14.5V8C14.5 7.44772 14.9477 7 15.5 7H18.5V3Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookf);
export default __webpack_public_path__ + "static/media/facebookf.3240b6f591db50f83d34a82f0af7aaa9.svg";
export { ForwardRef as ReactComponent };